import React, { Component } from 'react';
import './index.css';
import { message, Upload, Button, Modal, Table } from 'antd';
import { ExclamationCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import { 
    actionAddAdmin,
    actionDeleteAdmin,
    actionGetAdminInfo,
    actionUpdateOrgInfo,
    actionOperateUserFail,
} from '../../../../core/actions/user';
import NewAdmin from './newAdmin'
import UpdateIns from './updateIns'
import ImgCrop from 'antd-img-crop'

interface StateProps {
    orgInfo,
    adminList: any[],
    superAdmin: any,
    isSuccess: boolean,
    failData: string
}

interface DispatchProps {
    getAdminInfo(): void,
    updateOrgInfo(data, file?): void
    addAdmin(data): void
    deleteAdmin(data): void
    clearErrorData(): void
}

const { confirm } = Modal;

class Index extends Component<StateProps & DispatchProps> {
    
    state = {
        loading: false,
        imageUrl: '',
        visibleAdmin: false,
        visibleIns: false,
        confirmLoading: false,
    }

    componentDidMount () {
        this.props.getAdminInfo();
    }

    static getDerivedStateFromProps (props, state) {
        if(props.failData) {
            return {
                confirmLoading: false,
            }       
        }
        else if(props.isSuccess) {
            return {
                confirmLoading: false,
                visibleIns: false,
                visibleAdmin: false,
            }
        }
        return null;
    }

    Columns: any[] = [
        {
            title: 'ID',
            dataIndex: 'accountId',
            key: 'accountId'
        }, 
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName'
        }, 
        {
            title: '账号',
            dataIndex: 'mobileNumber',
            key: 'mobileNumber',
        }, 
        {
            title: '权限',
            dataIndex: 'roles',
            key: 'roles'
        },
        
    ];

    ColumnsSuper = [
        ...this.Columns,
        {
            title: '操作',
            render : (record) => {
                if(record.roles === '原始管理员') {
                    return <span></span>
                }
                return (
                    <div>
                        <a onClick={() => this.onDeleteAdmin(record)}>删除</a>
                    </div>
                )
            }
        }
    ]


    beforeUpload = (file) => {
        const isPng = file.type === 'image/png' ;
        if(!isPng) {
            message.error('只支持png图片!');
        }
        else {
            const orgInfo = this.props.orgInfo;
            let data = {
                organizationId: orgInfo.id
            }
            this.props.updateOrgInfo(data, file);
        }
        return false;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if(!isLt2M) {
            message.error('图片必须少于2MB!')
        }
        return isPng && isLt2M
    }

    getBase64(img, callBack) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callBack(reader.result));
        reader.readAsDataURL(img)
    }

    handleChange = info => {
        if(info.file.status === 'uploading') {
            this.setState({
                loading: true
            })
            return;
        }
        if(info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => {
                this.setState({
                    imageUrl,
                    loading: false
                })
            })
        }
    }

    onShowAdmin = () => {
        this.setState({
            visibleAdmin: true
        })
    }

    onAddAdmin = (formdata) => {
        console.log(formdata);
        this.props.addAdmin(formdata);
        this.setState({
            confirmLoading: true
        })
    }

    onCancelAdd = () => {
        this.setState({
            visibleAdmin: false,
            confirmLoading: false,
        })
        this.props.clearErrorData();
    }

    showUpdateIns = () => {
        this.setState({
            visibleIns: true
        })
    }

    onUpdateIns = (formdata) => {
        console.log(formdata);
        const orgInfo = this.props.orgInfo;
        let data = {
            name: formdata.name,
            organizationId: orgInfo.id
        }
        this.props.updateOrgInfo(data);
        this.setState({
            confirmLoading: true
        })
    }

    onCancelUpdate = () => {
        this.setState({
            visibleIns: false,
            confirmLoading: false,
        })
        this.props.clearErrorData();
    }

    onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
              const reader = new FileReader();
              reader.readAsDataURL(file.originFileObj);
              reader.onload = () => resolve(reader.result);
            });
          }
          const image = new Image();
          image.src = src;
          const imgWindow = window.open(src) as Window;
          imgWindow.document.write(image.outerHTML);
    }

    onDeleteAdmin = (item) => {
        const { deleteAdmin } = this.props;
        confirm({
            title: '确定删除管理员权限吗？',
            icon: <ExclamationCircleOutlined />,
            content: '删除后账号将不能登录后台',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                deleteAdmin(item)
            },
            onCancel() {

            }
        })
    }

    render () {

        const { loading  } = this.state;
        const uploadButton = (
            <div>
                {loading ? <LoadingOutlined /> : <PlusOutlined /> }
                <div style={{marginTop: 8}}>上传logo</div>
            </div>
        );
        const orgInfo = this.props.orgInfo || {};
        const imageUrl = orgInfo.organizationLogo || '';

        let adminList = this.props.adminList || [];
        let superAdmin = this.props.superAdmin || {};
        let username = localStorage.getItem('username');
        let Columns = this.Columns;
        if(superAdmin.mobileNumber === username) {
            Columns = this.ColumnsSuper;
        }

        return (
            <div className="setting">
                <div className="model">
                    <h3>机构信息</h3>
                    <ul>
                        <li>
                            <span>logo 设置</span>
                           <div>
                                <ImgCrop 
                                    rotate 
                                    aspect={368/133}
                                    modalTitle="编辑logo"
                                    modalOk="确定"
                                    modalCancel="取消"
                                    >
                                    <Upload
                                        name="logo"
                                        listType="picture-card"
                                        className="logo-uploader-ins"
                                        showUploadList={false}
                                        action=''
                                        beforeUpload={this.beforeUpload}
                                        onChange={this.handleChange}
                                        onPreview={this.onPreview}
                                        >
                                        {imageUrl ? <img src={imageUrl} alt='logo' style={{ width: '100%'}} /> : uploadButton}
                                    </Upload>
                                </ImgCrop>
                                <p className="tip">只支持.png格式, 推荐尺寸367*133</p>
                           </div>
                        </li>
                        <li>
                            <span>机构名称</span>
                            <span>
                                {orgInfo.name}
                                <a className="margin-left-20" onClick={() => this.showUpdateIns()}>修改</a>
                            </span>
                        </li>
                        <li>
                            <span>有效期</span>
                            <span>{orgInfo.validity}天</span>
                        </li>
                    </ul>
                </div>
                <div className="model">
                    <ul>
                        <li>
                            <span className="title">管理员设置</span>
                            <p>原始管理员账号不可删除 添加管理员可登录后台</p>
                        </li>
                        <li>
                            <span>管理员账号</span>
                            <span className="width-244">{superAdmin.mobileNumber}</span>
                            <Button 
                                type="primary" 
                                className="width-100" 
                                onClick={() => this.onShowAdmin()}
                                >添加</Button>
                        </li>
                        <Table 
                            rowKey={(record) => record.accountId}
                            dataSource={adminList} 
                            columns={Columns}
                            pagination={{
                                showSizeChanger: true,
                                defaultCurrent: 1,
                                total: adminList.length,
                                showTotal: total => `总 ${total} 条`
                            }}
                        />
                    </ul>
                </div>
                <NewAdmin 
                    failData={this.props.failData}
                    visible={this.state.visibleAdmin}
                    confirmLoading={this.state.confirmLoading}
                    onCreate={this.onAddAdmin}
                    onCancel={this.onCancelAdd}
                    />
                <UpdateIns 
                    data={orgInfo}
                    failData={this.props.failData}
                    visible={this.state.visibleIns}
                    confirmLoading={this.state.confirmLoading}
                    onCreate={this.onUpdateIns}
                    onCancel={this.onCancelUpdate}
                    />
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        orgInfo: state.user.orgInfo,
        adminList: state.user.adminList,
        superAdmin: state.user.superAdmin,
        isSuccess: state.user.isSuccess,
        failData: state.user.failData,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getAdminInfo: () => {
            dispatch(actionGetAdminInfo())
        },
        updateOrgInfo: (data, file?) => {
            dispatch(actionUpdateOrgInfo(data, file))
        },
        addAdmin: (data) => {
            dispatch(actionAddAdmin(data))
        },
        deleteAdmin: (data) => {
            dispatch(actionDeleteAdmin(data))
        },
        clearErrorData: () => {
            dispatch(actionOperateUserFail({
                data: ''
            }))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)